import React, { useState } from "react";
import { Option } from "../product/style.js";

const OptimizationToggleButton = (props) => {
  return (
    <div className="rounded-1 btn-group me-3 mb-3">
      <Option
        onClick={() => props.onClick("info")}
        className={`default-option ${
          props.mode === "info" ? "selected-option" : ""
        }`}
      >
        Info
      </Option>
      <Option
        onClick={() => props.onClick("cutlist")}
        className={`default-option ${
          props.mode === "cutlist" ? "selected-option" : ""
        }`}
      >
        Cutlist
      </Option>
    </div>
  );
};

export default OptimizationToggleButton;
